import { render, staticRenderFns } from "./RecurringCorePrices.vue?vue&type=template&id=a128fa3a&"
import script from "./RecurringCorePrices.vue?vue&type=script&lang=js&"
export * from "./RecurringCorePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports